import { emojiDefaults } from "@/components/emoji/emoji.type.ts";
import { SidebarHeader } from "@/components/sidebar/components/SidebarHeader.tsx";
import { usePermissionCheck } from "@/hooks/use-permissions.hook.ts";
import { useWorkflowExecutionWorkflows } from "@/queries/workflows/workflow-execution.query.ts";
import { Box, EmojiDisplay, SidebarPanelItem, Stack, Title } from "@skailer-com/uikit";
import { useTranslation } from "react-i18next";
import { useLocation, useSearchParams } from "react-router-dom";

export const SidebarWorkflows = () => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const [searchParams] = useSearchParams();
  const { canEditWorkflows, canViewAllWorkflowExecutions } = usePermissionCheck();
  const { data: workflows } = useWorkflowExecutionWorkflows();
  const canViewWorkflowExecutions = canViewAllWorkflowExecutions || Boolean(workflows?.length);
  const isLibraryActive =
    pathname === "/workflows" ||
    pathname.startsWith("/workflows/library") ||
    /^\/workflows\/[^/]+\/summary/.test(pathname);
  const isExecutionsPage =
    pathname.startsWith("/workflows/executions") || pathname.startsWith("/workflows/overview");
  const selectedWorkflowIds = searchParams.get("workflow_ids");
  const activeWorkflowId = isExecutionsPage
    ? workflows?.find((workflow) => String(workflow.id) === selectedWorkflowIds)?.id
    : undefined;

  return (
    <>
      <SidebarHeader title={t("workflow:workflows")} />
      <Stack className={"px-4 pb-6"}>
        <Stack gap={"sm"}>
          {canEditWorkflows && (
            <SidebarPanelItem
              to={"/workflows/library"}
              isActive={isLibraryActive}
              title={t("common:library")}
            />
          )}
          {canViewWorkflowExecutions && (
            <SidebarPanelItem
              to={"/workflows/executions"}
              isActive={isExecutionsPage && activeWorkflowId == undefined}
              title={t("workflow:executions")}
            />
          )}
        </Stack>

        {workflows && workflows.length > 0 && (
          <>
            <Box className={"px-2"}>
              <Title header={t("workflow:workflows")} size={"xs"} paddingBottom paddingTop />
            </Box>
            <Stack gap={"sm"}>
              {workflows.map((workflow) => (
                <SidebarPanelItem
                  key={`sidebar-workflow-${workflow.id}`}
                  to={`/workflows/executions?workflow_ids=${workflow.id}`}
                  isActive={workflow.id === activeWorkflowId}
                  title={workflow.title}
                  icon={
                    <EmojiDisplay
                      id={workflow.emoji || emojiDefaults.workflows.default}
                      size={"md"}
                    />
                  }
                />
              ))}
            </Stack>
          </>
        )}
      </Stack>
    </>
  );
};
